export default {
    init(promiseRequest) {
        return {
            getSharingUrls(eventId, matIds, pageSize, limit, colorSchema = "default") {
                return promiseRequest({
                    url: `/api/admin/events/${eventId}/sharing-urls`,
                    method: "post",
                    json: {
                        matIds: matIds,
                        pageSize: pageSize,
                        limit: limit,
                        colorSchema: colorSchema,
                    },
                }).then(res => {
                    if (res.statusCode !== 200) {
                        throw Error("Could not fetch sharing urls.");
                    }

                    return res.body;
                });
            },
        };
    },
};
